export default class {
	constructor(obj) {
		this.id = obj.id
		this.beginDate = obj.begindate
		this.endDate = obj.enddate
		this.nbMeasure = obj.nbmeasure
		this.nbDebits = obj.nbdebits
		this.nbHeight = obj.nbheight
		this.nbAnalysis = obj.nbanalysis
		this.typeId = obj.idtype
		this.stationId = obj.stationid
        this.samplingId = obj.samplingid
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoKeyFigures.js